var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-gray2 my-2 ps-1" }, [
    _c("ul", { staticClass: "items-list ob1-items-list-inline" }, [
      _c("li", [
        _c("div", { staticClass: "items-list-item" }, [
          _c("div", { staticClass: "item-container item-container-sm" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checked,
                    expression: "checked",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: _vm.id + "_yes",
                  type: "radio",
                  "aria-labelledby": _vm.id + "_label_yes",
                  name: _vm.name,
                },
                domProps: { value: true, checked: _vm._q(_vm.checked, true) },
                on: {
                  change: [
                    function ($event) {
                      _vm.checked = true
                    },
                    _vm.onChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "form-check-label",
                attrs: { "aria-hidden": "true", for: _vm.id + "_yes" },
              }),
            ]),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "item-text",
                attrs: { id: _vm.id + "label_yes", for: _vm.id + "_yes" },
              },
              [_vm._v("\n                        Oui\n                    ")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "items-list-item" }, [
          _c("div", { staticClass: "item-container item-container-sm" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checked,
                    expression: "checked",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: _vm.id + "_no",
                  type: "radio",
                  "aria-labelledby": _vm.id + "_label_no",
                  name: _vm.name,
                },
                domProps: { value: false, checked: _vm._q(_vm.checked, false) },
                on: {
                  change: [
                    function ($event) {
                      _vm.checked = false
                    },
                    _vm.onChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "form-check-label",
                attrs: { "aria-hidden": "true", for: _vm.id + "_no" },
              }),
            ]),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "item-text",
                attrs: { id: _vm.id + "label_no", for: _vm.id + "_no" },
              },
              [_vm._v("\n                        Non\n                    ")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }